<template>
  <div id="feedforwardSurvey">
    <el-card
      :style="{width: dialogWidth}"
      shadow="hover"
      :body-style="{padding: dialogPadding}"
    >
      <div v-if="$mq === 'laptop' || $mq === 'desktop'">
        <div class="title">
          {{ $t('coworker.feedforward.capturing') }}
        </div>

        <div class="description">
          <i18n path="coworker.feedforward.pleaseWrite">
            <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <template #leaderFullName>{{ leader.first_name }} {{ leader.last_name }}</template>
            <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <template #leaderFirstName>{{ leader.first_name }}</template>
          </i18n>
        </div>

        <div
          v-if="leader.lga1"
          class="lga"
        >
          <div class="lgaName">
            1. {{ leader.lga1 }}
          </div>

          <div class="lgaInput">
            <el-input
              v-model="lga1"
              type="textarea"
              :autosize="{minRows: 5, maxRows: 9}"
              resize="none"
            />
          </div>
        </div>

        <div
          v-if="leader.lga2"
          class="lga"
        >
          <div class="lgaName">
            2. {{ leader.lga2 }}
          </div>

          <div class="lgaInput">
            <el-input
              v-model="lga2"
              type="textarea"
              :autosize="{minRows: 5, maxRows: 9}"
              resize="none"
            />
          </div>
        </div>

        <div class="action">
          <el-button
            type="primary"
            round
            :disabled="!lga1 && !lga2"
            @click="submitFeedforward"
          >
            {{ $t('common.submit') }}
          </el-button>
        </div>
      </div>
      <div
        v-else
        id="compactSurvey"
      >
        <div v-if="scene === 1">
          <div class="title">
            {{ $t('coworker.feedforward.capturing') }}
          </div>
          <div class="description">
            <i18n path="coworker.feedforward.pleaseWrite">
              <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
              <template #leaderFullName>{{ leader.first_name }} {{ leader.last_name }}</template>
              <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
              <template #leaderFirstName>{{ leader.first_name }}</template>
            </i18n>
          </div>

          <el-button
            type="primary"
            round
            @click="sceneChange('next')"
          >
            {{ $t('common.start') }}
          </el-button>
        </div>

        <div v-else-if="scene === 2">
          <div class="lgaName">
            1. {{ leader.lga1 }}
          </div>
          <div class="lgaInput">
            <el-input
              v-model="lga1"
              type="textarea"
              :autosize="{minRows: 5, maxRows: 9}"
              resize="none"
            />
          </div>

          <el-button
            v-if="leader.lga2"
            type="primary"
            round
            @click="sceneChange('next')"
          >
            {{ $t('common.next') }}
          </el-button>
          <el-button
            v-else
            type="primary"
            round
            :disabled="!lga1 && !lga2"
            @click="submitFeedforward"
          >
            Submit
          </el-button>
        </div>

        <div v-else-if="scene === 3">
          <div class="lgaName">
            2. {{ leader.lga2 }}
          </div>
          <div class="lgaInput">
            <el-input
              v-model="lga2"
              type="textarea"
              :autosize="{minRows: 5, maxRows: 9}"
              resize="none"
            />
          </div>

          <el-col :span="12">
            <el-button
              type="info"
              round
              @click="sceneChange('back')"
            >
              {{ $t('common.back') }}
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              round
              :disabled="!lga1 && !lga2"
              @click="submitFeedforward"
            >
              {{ $t('common.submit') }}
            </el-button>
          </el-col>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    leader: {
      type: Object,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    confirmation: {
      type: Boolean,
      default: false,
    },
    dialogWidth: {
      type: String,
      default: '50%',
    },
    dialogPadding: {
      type: String,
      default: '20px',
    },
  },
  data() {
    return {
      lga1: null,
      lga2: null,
      scene: 1,
    };
  },
  methods: {
    async submitFeedforward() {
      try {
        const data = {};
        if (this.lga1) data.lga1 = this.lga1;
        if (this.lga2) data.lga2 = this.lga2;
        await api.submitFeedforward(this.$route.params.id, data);
        this.$emit('update:confirmation', true);
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
          this.$emit('update:errorText', err.msg);
        }
        this.$emit('update:error', true);
      }
    },
    sceneChange(option) {
      if (option === 'next') {
        if (this.scene === 1 && this.leader.lga1) {
          this.scene = 2;
        } else if (this.scene === 1 && !this.leader.lga1) {
          this.scene = 3;
        } else if (this.scene === 2 && this.leader.lga2) {
          this.scene = 3;
        }
      } else if (option === 'back') {
        if (this.scene === 3 && this.leader.lga1) {
          this.scene -= 1;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#feedforwardSurvey {
  width: 100%;

  .el-card {
    margin: 0 auto;
    text-align: left;
    overflow: auto;
    background-color: rgba(255, 255, 255, 0.9);

    .title {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 25px;
    }

    .description {
      margin-bottom: 15px;
    }

    .lga {
      margin-bottom: 30px;

      .lgaName {
        font-weight: bold;
        word-break: break-word;
      }
    }

    .action {
      text-align: center;
      margin-top: 50px;

      .el-button {
        width: 40%;
      }
    }
  }

  #compactSurvey {
    margin: 0 auto;

    .lgaName {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 15px;
      word-break: break-word;
    }

    .el-col {
      padding: 0 1%;
      margin: 0 auto 20px;
    }

    .el-button {
      width: 100%;
      margin: 20px auto;
    }
  }
}
</style>

<style lang="scss">
  #feedforwardSurvey {
    .lga {
      .el-textarea__inner {
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      }
    }
  }
</style>
